import React, { useState, useEffect } from "react";
import axios from "../../services/axios";
import { useNavigate, useLocation } from "react-router";
import useAuth from "../../hooks/useAuth";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import Spinner from "../../components/utils/spinner";
import SoloCategoryCard, {
  SoloCategoryNew,
} from "../../components/solo/categoryCard";

function HeaderLeft() {
  const navigate = useNavigate();
  const handlePress = () => {
    navigate("/solo");
  };
  return <BackHeaderLeft onClick={handlePress} />;
}

export default function SoloCategories() {
  const navigate = useNavigate();
  const { player } = useLocation().state;
  const [categories, setCategories] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    axios
      .get(`/solo/getAllCategories?id_usuario=${user.id_usuario}`)
      .then((response) => {
        setCategories(response.data);
      });
  }, []);

  const handleClick = (category) => {
    navigate("/solo/game", {
      state: { category, playerIndex: player },
    });
  };

  const handleNewClick = () => {
    navigate("/solo/player-categories");
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll className="ps-5 pe-5">
        {!categories?.length ? (
          <div className="flex justify-center">
            <Spinner />
          </div>
        ) : (
          <div>
            {categories.map((category, index) => {
              let key = `category-${category.id_cat_solo}`;
              if (category?.custom) {
                key = `category-custom-${category.id_categorias_solo_usuario}`;
              }
              return (
                <SoloCategoryCard
                  key={key}
                  index={index}
                  category={category}
                  onClick={handleClick}
                />
              );
            })}
            <SoloCategoryNew
              onClick={handleNewClick}
              index={categories.length}
            />
          </div>
        )}
      </NoHeaderScroll>
    </div>
  );
}
